import { ulid } from "ulid";
import { IGroup } from "../common/IGroup.intf";
import { ITriggerData, ITriggerJavaData, ITriggerShellData } from "./ITrigger.intf";
import { createMergeToDefaultData } from "../utils/mergeToDefaultData";
export const triggerGroupType = 'triggerGroup'
export interface ITriggerGroup extends IGroup<ITriggerData<ITriggerShellData, ITriggerJavaData>>{
    type:string
    id:string
}      

function createDefultData():ITriggerGroup{
    return {
        type:triggerGroupType,
        id:ulid(),
        list:[],
        checks:[],
        isSequential:true
    }
}

export interface ITriggerGroupUtils{
    type:string
    createDefultData:()=>ITriggerGroup
    mergeDataToDefultData:(data:Partial<ITriggerGroup>)=>ITriggerGroup
}

export const triggerGroupUtils:ITriggerGroupUtils = {
    type:triggerGroupType,
    createDefultData,
    mergeDataToDefultData:createMergeToDefaultData(createDefultData)
}

